document.addEventListener('alpine:init', () => {
  Alpine.data('recentlyViewed', (el) => ({
    // ——— State from data-attributes ———
    max:       parseInt(el.dataset.count)       || 8,
    show:      parseInt(el.dataset.show)        || 8,
    current:   el.dataset.productHandle         || '',

    // ——— Internal state ———
    handles:   [],
    loading:   false,
    list:      null,
    canScrollPrev: false,
    canScrollNext: false,
    progress:     0,
    slideWidth:   0,
    visibleCount: 1,

    _initialized: false,

    init() {
      if (this._initialized) return;
      this._initialized = true;

      this.list = this.$refs.list;
      this._saveToLocal();
      this._loadHandles();
      this._fetchCards().then(() => {
        // once cards are in DOM, wire up the slider
        this.update();
        this.list.addEventListener('scroll', () => this.update());
        window.addEventListener('resize',  () => this.update());
      });
    },

    _saveToLocal() {
      if (!this.current) return;
      const key = 'recently-viewed';
      let arr = JSON.parse(localStorage.getItem(key) || '[]');
      arr = [this.current, ...arr.filter(h => h !== this.current)];
      arr = arr.slice(0, 20);
      localStorage.setItem(key, JSON.stringify(arr));
    },

    _loadHandles() {
      const arr = JSON.parse(localStorage.getItem('recently-viewed') || '[]');
      this.handles = arr.filter(h => h !== this.current).slice(0, this.max);
    },

    async _fetchCards() {
      if (!this.handles.length) return;
      this.loading = true;
      this.list.innerHTML = '';
      const seen = new Set();
      let count = 0;

      const root       = window.Shopify?.routes?.root       || '/';
      const searchBase = window.Shopify?.routes?.search_url || `${root}search`;

      for (const handle of this.handles) {
        if (count >= this.show) break;
        const url = `${searchBase}?view=ga-card-product&type=product&q=${encodeURIComponent('handle:' + handle)}`;
        try {
          const res  = await fetch(url, { credentials: 'same-origin' });
          const html = await res.text();
          const tmp  = document.createElement('div');
          tmp.innerHTML = html;

          const li = tmp.querySelector(`li[data-handle="${handle}"]`);
          if (li && !seen.has(handle)) {
            seen.add(handle);
            // ensure slider classes
            li.classList.add(
              'ga:flex-none',
              'ga:[width:calc((100%-theme(spacing.4))/2)]',
              'ga:sm:[width:calc((100%-theme(spacing.4)*2)/3)]',
              'ga:lg:[width:calc((100%-theme(spacing.4)*3)/4)]',
              'ga:snap-start'
            );
            this.list.appendChild(li);
            count++;
          }
        } catch (e) {
          console.error('recent fetch error for', handle, e);
        }
      }

      // un-hide once we have items
      if (this.list.children.length) {
        el.classList.remove('ga:hidden');
      }
      this.loading = false;
    },

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.list;
      this.canScrollPrev = scrollLeft > 0;
      this.canScrollNext = scrollLeft + clientWidth < scrollWidth - 1;

      if (scrollWidth > 0) {
        // progress = visible portion / total
        const filled = scrollLeft + clientWidth;
        this.progress = Math.min((filled / scrollWidth) * 100, 100);

        // compute how many slides fit
        this.slideWidth   = this.list.querySelector('li')?.clientWidth || clientWidth;
        this.visibleCount = Math.floor(clientWidth / this.slideWidth) || 1;
      } else {
        this.progress = 0;
      }
    },

    prev() {
      this.list.scrollBy({ left: -this.slideWidth * this.visibleCount, behavior: 'smooth' });
    },

    next() {
      this.list.scrollBy({ left:  this.slideWidth * this.visibleCount, behavior: 'smooth' });
    }
  }));
});